import type { MetaFunction } from "@remix-run/node"
import { Assets } from "./shared/assets.ts"
import { BasicLayout } from "./shared/basic-layout.tsx"
import { COMPANY_NAME } from "./shared/constants.ts"

export const meta: MetaFunction = () => {
  return [{ title: `Not Found | ${COMPANY_NAME}` }]
}

export default function NotFoundRoute() {
  return (
    <BasicLayout>
      <img
        src={Assets.images.logo}
        alt="Krost logo"
        className="w-20 object-contain fixed top-4 left-1/2 -translate-x-1/2"
      />
      <div className="flex flex-col items-center justify-center h-full text-sm">
        <h1 className="mb-2">Not Found</h1>
        <p className="text-gray-11">The requested page could not be found.</p>
      </div>
    </BasicLayout>
  )
}
